import React, { useState, useEffect } from "react";
import { Button, Container, Grid, GridColumn, GridRow, Segment } from "semantic-ui-react";
import ResourcesUploadForm from "./ResourcesUploadForm";
import format from "date-fns/format";
import { deleteResource, getAuthUser} from "../resourceActions";
import { Link } from "react-router-dom";
import firebase from "../../../app/config/firebase";
const firestore = firebase.firestore();

export default function ResourcesDashboardPage(props) {
    const [clientView, setClientView] = useState(false);
    const [profile, setProfile] = useState([]);
    const [resourcesUser, setResourcesUser] = useState([]);
    const [resourcesCompany, setResourcesCompany] = useState([]);
    const [resourcesAll, setResourcesAll] = useState([]);
    const [authUser, setAuthUser] = useState([]);


    let id = "";
    if (props.match.params.id) {
        id = props.match.params.id;
    } else {
        id = firebase.auth().currentUser.uid;
    }

    useEffect(() => {
        getAuthUser().then(
            (res) => {
                if (res.exists) {
                    setAuthUser(res.data());

                    if (id !== res.data().id && id !== "") {
                        setClientView(true);
                    } else {
                        setClientView(false);
                    }
                }
            },
            (err) => {
                console.log(err);
            }
        );

        const unsubscribe1 = firestore
            .collection("resources")
            .where("viewedBy", "==", "All")
            .onSnapshot((snapshot) => {
                let list = [];
                snapshot.forEach((doc) => {
                    if (doc.exists) {
                        let appObj = { ...doc.data(), id: doc.id };
                        list.push(appObj);
                    }
                });

                let resourcesAll = [];

                Object.keys(list).forEach(function (key) {
                    let type = "type" in list[key];
                    if (type === false) {
                        resourcesAll.push(list[key]);
                    }
                });

                setResourcesAll(resourcesAll);
            });

        const unsubscribe2 = firestore
            .collection("resources")
            .where("userUid", "==", id)
            .onSnapshot((snapshot) => {
                let list = [];
                snapshot.forEach((doc) => {
                    if (doc.exists) {
                        let appObj = { ...doc.data(), id: doc.id };
                        list.push(appObj);
                    }
                });

                let resourcesUser = [];
                Object.keys(list).forEach(function (key) {
                    let type = "type" in list[key];
                    if (type === false) {
                        resourcesUser.push(list[key]);
                    }
                });

                setResourcesUser(resourcesUser);
            });

        const unsubscribe3 = firestore
            .collection("users")
            .doc(id)
            .onSnapshot((res) => {
                if (res.exists) {
                    setProfile(res.data());

                    firestore
                        .collection("resources")
                        .where("companyId", "==", res.data().companyId)
                        .where("userUid", "==", "None")
                        .onSnapshot((snapshot) => {
                            let list = [];
                            snapshot.forEach((doc) => {
                                if (doc.exists) {
                                    let appObj = { ...doc.data(), id: doc.id };
                                    list.push(appObj);
                                }
                            });
                            let resourcesCompany = [];

                            Object.keys(list).forEach(function (key) {
                                let type = "type" in list[key];
                                if (type === false) {
                                    resourcesCompany.push(list[key]);
                                }
                            });

                            setResourcesCompany(resourcesCompany);
                        });
                }
            });

        return () => {
            unsubscribe1();
            unsubscribe2();
            unsubscribe3();
        };
    }, []);

    function close() {
    }

    function removeFile(resource) {
        resource.documentFile = "own";
        deleteResource(resource);
    }

    return (
        <Container>
            {profile.isSuper === true || profile.isAdmin === true /*|| profile.isHR === true*/ ? <ResourcesUploadForm authUser={authUser} /> : null}
            {clientView === true && (
                <Segment style={{ marginBottom: "20px" }}>
                    <Grid>
                        <Grid.Row columns={2}>
                            <Grid.Column>
                                <h1>Staff Member: {profile.displayName ? profile.displayName : profile.email}</h1>
                            </Grid.Column>

                            <Grid.Column textAlign="right">
                                <Link className="ui button" as="a" to={"/home/" + profile.id}>
                                    Back to Dashboard
                                </Link>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Segment>
            )}
            {resourcesUser && resourcesUser.length === 0 && resourcesCompany && resourcesCompany.length === 0 && resourcesAll && resourcesAll.length === 0 && <p>No Documents Uploaded</p>}
            {resourcesUser &&
                resourcesUser.length > 0 &&
                resourcesUser.map((resource) => (
                    <Segment secondary key={resource.id}>
                        <Grid>
                            <GridRow>
                                <GridColumn width="four" verticalAlign="middle">
                                    {resource.documentName}
                                </GridColumn>

                                <GridColumn width="twelve">
                                    <Segment>
                                        <Grid>
                                            <GridRow>
                                                <GridColumn width="eight" verticalAlign="middle">
                                                    {format(resource.date.toDate(), "d MMMM yyyy")}
                                                    <br />
                                                    Version {resource.version}
                                                </GridColumn>

                                                <GridColumn width="eight" textAlign="right">
                                                    <Button color="blue" as="a" target="_blank" href={resource.fileUrl}>
                                                        Download File
                                                    </Button>

                                                    {(authUser.isSuper || authUser.isAdmin) && (
                                                        <Button color="red" onClick={() => window.confirm("Are you sure you wish to delete this item?") && deleteResource(resource)}>
                                                            Delete File
                                                        </Button>
                                                    )}
                                                </GridColumn>
                                            </GridRow>
                                        </Grid>
                                    </Segment>
                                </GridColumn>
                            </GridRow>
                        </Grid>
                    </Segment>
                ))}
            {resourcesCompany &&
                resourcesCompany.length > 0 &&
                resourcesCompany.map((resource) => (
                    <Segment secondary key={resource.id}>
                        <Grid>
                            <GridRow>
                                <GridColumn width="four" verticalAlign="middle">
                                    {resource.documentName}
                                </GridColumn>

                                <GridColumn width="twelve">
                                    <Segment>
                                        <Grid>
                                            <GridRow>
                                                <GridColumn width="eight" verticalAlign="middle">
                                                    {format(resource.date.toDate(), "d MMMM yyyy")}
                                                    <br />
                                                    Version {resource.version}
                                                </GridColumn>

                                                <GridColumn width="eight" textAlign="right">
                                                    <Button color="blue" as="a" target="_blank" href={resource.fileUrl}>
                                                        Download File
                                                    </Button>

                                                    {(authUser.isSuper || authUser.isAdmin) && (
                                                        <Button color="red" onClick={() => window.confirm("Are you sure you wish to delete this item?") && deleteResource(resource)}>
                                                            Delete File
                                                        </Button>
                                                    )}
                                                </GridColumn>
                                            </GridRow>
                                        </Grid>
                                    </Segment>
                                </GridColumn>
                            </GridRow>
                        </Grid>
                    </Segment>
                ))}
            {resourcesAll &&
                resourcesAll.length > 0 &&
                resourcesAll.map((resource) => (
                    <Segment secondary key={resource.id}>
                        <Grid>
                            <GridRow>
                                <GridColumn width="four" verticalAlign="middle">
                                    {resource.documentName}
                                </GridColumn>

                                <GridColumn width="twelve">
                                    <Segment>
                                        <Grid>
                                            <GridRow>
                                                <GridColumn width="eight" verticalAlign="middle">
                                                    {format(resource.date.toDate(), "d MMMM yyyy")}
                                                    <br />
                                                    Version {resource.version}
                                                </GridColumn>

                                                <GridColumn width="eight" textAlign="right">
                                                    <Button color="blue" as="a" target="_blank" href={resource.fileUrl}>
                                                        Download File
                                                    </Button>

                                                    {authUser.isSuper && (
                                                        <Button color="red" onClick={() => window.confirm("Are you sure you wish to delete this item?") && deleteResource(resource)}>
                                                            Delete File
                                                        </Button>
                                                    )}
                                                </GridColumn>
                                            </GridRow>
                                        </Grid>
                                    </Segment>
                                </GridColumn>
                            </GridRow>
                        </Grid>
                    </Segment>
                ))}
        </Container>
    );
}
